<div
	tabindex="-1"
	attr.aria-label="{{ pageTitle | translate }}"
	id="main-wrapper"
	role="document"
	(dragstart)="onDragStart($event)"
	(drop)="onDrop($event)"
	>

	<vtr-material-menu
		[hidden]="!isMachineInfoLoaded"
		[loadMenuItem]="machineInfo">
	</vtr-material-menu>

	<div tabindex="-1" class="vtr-app container-fluid" cdkScrollable>
		<div class="row">
			<div class="col p-0  sub-app-iframe-container">
				<router-outlet (activate)="onActivate($event)"></router-outlet>
			</div>
		</div>
	</div>
</div>
